import { render } from "./UserBooking.vue?vue&type=template&id=fa838300&scoped=true"
import script from "./UserBooking.vue?vue&type=script&lang=js"
export * from "./UserBooking.vue?vue&type=script&lang=js"

import "./UserBooking.vue?vue&type=style&index=0&id=fa838300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa838300"]])

export default __exports__